// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"0ac90262","848":"3d870122"}[chunkId] + ".chunk.js";
};